import React from "react";
import { Link } from "react-router-dom";
import { PostType } from "./postsList";

interface IProps {
  post: PostType;
}

const PostItem: React.FC<IProps> = ({ post }) => (
  //will have just writing for now, and then expand to Phot albums / Current projects / Music etc..
  //    "type": "Writing/PhotoAlbum/Project/Music",

  <div className="post blur-bg">
    <h3 className="">{post.title}</h3>
    <p className="post-slug">{post.slug}</p>
    <Link to={`/post/${post.id}`} className="post-link">
      {post.thumbnail && (
        <img
          src={post.thumbnail}
          className="post-img"
          alt={post.thumbnailAltTag}
        />
      )}
      <u>Read Post</u>
    </Link>
    <p>{post.date}</p>
  </div>
);

export default PostItem;
